import { Form, Formik } from "formik";
import { Button } from "primereact/button";
import { FormLoginProps } from "./types";
import { PasswordInputField, SimpleTextField } from "@components";
import React from "react";
import { STRING } from "@constants";

export function FormSignIn(props: Readonly<FormLoginProps>) {
  const { onSubmit, loading, validationSchema } = props;

  return (
    <Formik
      initialValues={{ email: "", password: "" }}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      <Form>
        <div className="input-wrapper mb-3">
          <div className="relative">
            <i className="pi pi-envelope input-icon absolute left-4 text-gray-500 text-base" />
            <SimpleTextField
              id="email"
              type="email"
              name="email"
              label={STRING.LOGIN.EMAIL_LABEL}
            />
          </div>
        </div>

        <div className="input-wrapper mb-3">
          <div className="relative">
            <i className="pi pi-lock input-icon absolute left-4 text-gray-500" />
            <PasswordInputField
              id="password"
              inputId="password"
              name="password"
              inputClassName="w-full"
              label={STRING.LOGIN.PASSWORD_LABEL}
            />
          </div>
        </div>

        <Button
          type="submit"
          label={
            loading
              ? STRING.LOGIN.SUBMIT_LOADING_LABEL
              : STRING.LOGIN.SUBMIT_LABEL
          }
          icon={loading ? "pi pi-spin pi-spinner" : "pi pi-sign-in"}
          loading={loading}
          className="login-button w-full text-white"
          disabled={loading}
        />
      </Form>
    </Formik>
  );
}
